"use client";

import { useLanguage } from "@/context/LanguageContext";

export default function DirectionWrapper({ children }: { children: React.ReactNode }) {
  const { dir, language } = useLanguage();

  return (
    <div
      dir={dir}
      lang={language}
      style={language === "ar" ? { fontFamily: "'Noto Sans Arabic', sans-serif" } : undefined}
    >
      {children}
    </div>
  );
}
